import { injectable } from 'tsyringe';
import { ApiRoutes } from '../apiConfig/ApiRoutes';
import { BaseApi } from '../apiConfig/BaseApi';
import { plainToInstance } from 'class-transformer';
import { Customer } from '$src/domain/customers/Customer';
import { IProjectRepository } from '$src/domain/projects/IProjectRepository';
import { Project } from '$src/domain/projects/Project';
import { ProjectIdentifier } from '$src/domain/projects/ProjectIdentifier';
import { CreateProjectData } from '$src/domain/projects/CreateProjectData';

@injectable()
export class ProjectRepositoryApi extends BaseApi implements IProjectRepository {
  
   
    protected static getRoute(groupStoreId: string, path1?: string, path2?: string): string {
        if (path1 && path2) {
            return `${ApiRoutes.PROJECTS.endpoint(groupStoreId)}/${path1}/${path2}`;
        } else if( path1) {
            return `${ApiRoutes.PROJECTS.endpoint(groupStoreId)}/${path1}`;
        } else {
            return `${ApiRoutes.PROJECTS.endpoint(groupStoreId)}`;
        }
    }

    async getProjectById(groupStoreId: number, projectId: number): Promise<Project> {
        try {

            const route = ProjectRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());

            const response = await this.apiClient.get<Project>(route);
            
            return response;
        } catch (error) {
            console.error('Error fetching project by id:', error);
            throw error; 
        }
    }

    async getCustomerByProjectId(groupStoreId: number, projectId: number): Promise<Customer> {
        try {

            const route = ProjectRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), 'customer');

            const response = await this.apiClient.get<Customer>(route);
            
            return response;
            //plainToInstance(Customer, response);
        } catch (error) {
            console.error('Error fetching customer by project id:', error);
            throw error; 
        }
    }

    async createProject(groupStoreId: number, data: CreateProjectData): Promise<ProjectIdentifier> {
        try {
            const route = ProjectRepositoryApi.getRoute(groupStoreId.toString());
            
            return await this.apiClient.post(route, data);
        } catch (error) {
            console.error('Error creating project', error);
            throw error; 
        }
    }

    async deleteProject(groupStoreId: number, projectId: number): Promise<ProjectIdentifier> {
        try {
            const route = ProjectRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString());
            
            return await this.apiClient.delete(route);
        } catch (error) {
            console.error('Error deleting project', error);
            throw error; 
        }
    }

    async orderProject(groupStoreId: number, projectId: number): Promise<ProjectIdentifier> {
        try {
            const route = ProjectRepositoryApi.getRoute(groupStoreId.toString(), projectId.toString(), 'order');
            
            return await this.apiClient.post(route, null);
        } catch (error) {
            console.error('Error ordering project', error);
            throw error; 
        }
    }
}
